<template>
    <VListItem v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
    </VListItem>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item';

export default {
    name: 'SrListItem',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
